import { PROFILE_KEY } from '../../constants'
import { isEmptyUtil } from 'packages/src'

function beforeSaveProfileHook (data) {
  let updates = {}
  const weight = data[PROFILE_KEY.WEIGHT]
  if (weight != null) {
    updates = {
      [PROFILE_KEY.WEIGHT]: parseFloat(weight)
    }
  }
  const height = data[PROFILE_KEY.HEIGHT]
  if (height != null) {
    updates = {
      ...updates,
      [PROFILE_KEY.HEIGHT]: parseFloat(height)
    }
  }

  if (isEmptyUtil(updates)) {
    return data
  }

  return {
    ...data,
    ...updates
  }
}

export default beforeSaveProfileHook
